import {FormTypes} from './constants';
import {mapState, mapActions, mapGetters} from 'vuex';
import NormalForm from './components/NormalForm';
import DrawableForm from './components/DrawableForm';
import pagingMixin from './pagingMixin';
export default {
    components: {
        NormalForm,
        DrawableForm
    },
    data: () => ({
        show: false,
        pagedForms: []
    }),
    mixins:[pagingMixin],
    computed: {
        ...mapState('form', ['selectedForm']),
        title() {
            if (this.selectedForm) {
                return `${this.selectedForm.applicant.name} - ${this.roomName(this.selectedForm)} - ${this.getFormTypeStr(this.selectedForm.type)}`;
            }
            return '';
        },
        applicant(){
            if (this.selectedForm) {
                return this.selectedForm.applicant.name;
            }
            return '';
        },
        
        isDrawableForm() {
            if (this.selectedForm) {
                return this.selectedForm.type === FormTypes.Drawable;
            }
            return false;
        },
        isDenied() {
            if (this.selectedForm) {
                return this.selectedForm.isDenied;
            }
            return false;
        },
        signHistory(){
            if (this.selectedForm) {
                return this.selectedForm.signHistory;
            }
            return [];
        }
    },
    watch:{
      pagedData(current){
          this.pagedForms = [...current];
      }
    },
    methods:{
        ...mapActions('form', {
            getForm: 'getFormAction'
        }),
        async selectAndShow(row) {
            await this.select(row);
            this.showThis();
        },
        async select({id}) {
            await this.getForm(id);
        },
        showThis(){
            this.show = true;
        },
        getFormTypeStr(type) {
            if (type) {
                switch (type) {
                    case FormTypes.Drawable:
                        return '抽籤登記表';
                    case FormTypes.Normal:
                        return '預約登記表';
                    case FormTypes.Super:
                        return '管理者登記';
                }
            }
            return '';
        },
        roomName({type, roomName, ncutRoomName}) {
            if (type === FormTypes.Normal || type === FormTypes.Super) return roomName;
            return ncutRoomName;
        }
    }
}
